// TODO: figure out why if import MediaDisplayerContext on the specific import breaks project
// Somehow is related with the export of routeCollectionContext inside @/shared/contexts/index
import { useContext } from "react";

import { MediaDisplayerContext } from "@/shared/contexts";
import { IMediaDisplayerContext } from "@/shared/contexts/mediaDisplayerContext";

export const useMediaDisplayer = (): IMediaDisplayerContext => {
    const context = useContext(MediaDisplayerContext);

    return {
        displayFullMode: context.displayFullMode,
        displaySizedMode: context.displaySizedMode,
    };
};
